import ProductPrinterWebsite from "../../../../configurator/js/lib/productPrinterWebsite";
import ProductPrinter from "./productPrinter";
import AccessoiresPrinter from "./accessoiresPrinter";
import ConnectorPrinter from "./connectorPrinter";

if (!process.env.JEST_WORKER_ID !== undefined) {
  window.ProductPrinterWebsite = ProductPrinterWebsite
  window.ProductPrinter = () => new ProductPrinter()
  window.AccessoiresPrinter = () => new AccessoiresPrinter()
  window.ConnectorPrinter = () => new ConnectorPrinter()

  window.addEventListener('focus', () => {
    window.ProductPrinter().removeOldTemplate()
  })
}
